import React from 'react';
import { Link } from 'react-router-dom';
import logoColor from '../assets/images/panela-logo-color.png';
import './Logo.css';

const Logo = ({ variant = 'header', className = '' }) => {
  return (
    <Link to="/" className={`logo ${className}`}>
      <img 
        src={logoColor} 
        alt="Panela Crumbs" 
        className={`logo-image logo-image-${variant}`} 
      />
    </Link>
  );
};

export default Logo; 